import type { EntityDetailSchema } from '@web-config-app/core';
import { useQuery } from '@tanstack/react-query';

interface UseEntitySchemaProps {
  entityId: string | undefined;
  schemaPath?: string;
}

export const useEntitySchema = ({
  entityId,
  schemaPath = '/schemas',
}: UseEntitySchemaProps) => {
  const { data: schema, isError } = useQuery<EntityDetailSchema>({
    queryKey: ['schemas', entityId],
    queryFn: async () => {
      const response = await fetch(`${schemaPath}/${entityId}.json`);
      return response.json();
    },
    retry: false,
    enabled: !!entityId,
  });

  return { schema: isError ? undefined : schema, isError };
};
